<template>
  <b-modal v-model="showModal" hide-footer hide-header centered>
    <b-overlay spinner-variant="primary" :show="isLoading">
      <b-alert show variant="danger" class="mt-2 py-1 px-1">
        <h4>Увага! Користувача буде видалено назавжди.</h4>
      </b-alert>
      <div class="cta mb-2">
        <b-button variant="danger" block size="lg" @click="removeUser">
          Видалити користувача
        </b-button>
        <b-button
          block
          class="mt-1"
          variant="outline-primary"
          @click="closeModal"
        >
          Скасувати
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  props: ["show", "uid"],
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    showModal() {
      return this.show;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async removeUser() {
      this.isLoading = true;
      await this.$api
        .get("/user/delete/?uid=" + this.uid)
        .then((response) => {
          if (response.data.code == "success") {
            this.$toast.success("Користувача видалено");
            this.$emit("update");
          }
        })
        .catch((error) => {
          console.log(error);
        });

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
